import { render, staticRenderFns } from "./Appuntamento_body.vue?vue&type=template&id=62b207c2"
import script from "./Appuntamento_body.vue?vue&type=script&lang=js"
export * from "./Appuntamento_body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports